export enum RevirGoogleTypeEnum {
  ALWAYS_VIEW = 1,
  NEVER_VIEW = 2,
  BASED_ON_THE_STARS_NUMBER = 3,
}
